module.exports = __webpack_public_path__ + "static/media/2_en.b12702fa.png";